export const label = 'font-medium block text-base font-body text-textMid';
export const wrapper = 'h-full bg-white pt-2 pb-4 px-4 flex-col flex';
